import request from '@/utils/request'

export function login(data) {
    return request({
        url: '/admin/Login/login',
        method: 'post',
        data
    })
}

export function getInfo(token) {
    return request({
        url: '/admin/AdminUser/info',
        method: 'get',
        params: { token }
    })
}

export function logout(token, userid) {
    return request({
        url: '/admin/Login/logout',
        method: 'get',
        params: {
            // token,
            // id: userid
        }
    })
}

/**
 * 验证码
 *  @param {array} params 请求参数
 */
export function verify(params) {
    return request({
        url: '/admin/Login/verify',
        method: 'get',
        params: params
    })
}

/**
 * 用户分配权限
 * @param {array} data 请求数据
 */
export function rule(data, method = 'get') {
    if (method === 'post') {
        return request({
            url: '/admin/AdminUser/rule',
            method: 'post',
            data
        })
    } else {
        return request({
            url: '/admin/AdminUser/rule',
            method: 'get',
            params: data
        })
    }
}


export function newrule(data, method = 'get') {

    return request({
        url: 'admin/AdminRole/list',
        method: 'get',
        params: data
    })

}

export function get_show_logo(data, method = 'get') {
    return request({
        url: 'admin/AdminSysconfig/getConfig',
        method: 'get',
        params: data
    })

}